import { useState } from "react";
import { Carousel } from "react-responsive-carousel";
import { NavLink } from "react-router-dom";
import PumaFamilyHero from "./PumaFamilyHero";
import FocusFallSlide from "./FocusFallSlide";
import "react-responsive-carousel/lib/styles/carousel.min.css";

export default function HeroCarousel() {
  const [selectedSlide, setSelectedSlide] = useState(0);

  return (
    <Carousel
      autoPlay={true}
      showThumbs={false}
      infiniteLoop={true}
      dynamicHeight={false}
      showStatus={false}
      onChange={setSelectedSlide}
    >
      <div>
        <FocusFallSlide active={selectedSlide === 0} />
      </div>
      <div>
        <PumaFamilyHero
          variant="carousel"
          active={selectedSlide === 1}
          ctaHref="/landing/puma-family-2026"
          ctaLabel="Научете повече"
        />
      </div>

      {/* Ranger Q3 2026 Slide */}
      <div>
        <section className="relative">
          <NavLink to="/landing/ranger-q3-2026" className="block">
            <div className="hidden lg:block">
              <img
                src="../images/ranger-q3-2026/1440x516_Ford_Ranger.jpg"
                alt="Ford Ranger Q3 2026"
                className="w-full"
              />
              <div className="absolute inset-y-0 left-0 hidden w-[40%] bg-gradient-to-r from-black/80 to-transparent lg:block" />
            </div>
            <div className="block lg:hidden">
              <img
                src="../images/ranger-q3-2026/768x950_Ford_Ranger.jpg"
                alt="Ford Ranger Q3 2026"
                className="w-full"
              />
              <div className="absolute inset-x-0 top-0 h-[40%] bg-gradient-to-b from-black/80 to-transparent lg:hidden" />
              <div className="absolute left-[5%] right-[5%] top-2 z-10 text-left text-white lg:hidden">
                <p className="text-sm tracking-[0.22em] uppercase font-fordMedium">
                  Ford Ranger
                </p>
                <h1 className="mt-2 text-2xl leading-[1.05] uppercase font-fordBlack">
                  На специална цена
                  <br />и с ниска първоначална вноска
                </h1>
                <p className="mt-2 text-xl font-fordMedium">
                  от 3 299 € без ДДС
                  <span className="text-xs align-super">*</span>
                </p>
              </div>
              <div className="absolute inset-x-0 z-10 text-center bottom-12 lg:hidden">
                <button className="px-4 py-1.5 text-sm tracking-wide text-white uppercase border border-white rounded-full hover:bg-white hover:text-fordBlue">
                  Научете повече
                </button>
              </div>
            </div>
            <div className="absolute hidden left-[2%] top-4 bottom-8 z-10 max-w-3xl flex-col justify-between text-left text-white lg:flex">
              <div>
                <p className="text-base tracking-[0.22em] uppercase font-fordMedium">
                  Ford Ranger
                </p>
                <h1 className="mt-2 text-2xl uppercase font-fordBlack">
                  На специална цена
                  <br />и с ниска
                  <br />
                  първоначална
                  <br />
                  вноска
                </h1>
                <p className="mt-2 text-xl font-fordMedium">
                  от 3 299 € без ДДС
                  <span className="text-xs align-super">*</span>
                </p>
              </div>
              <div>
                <button className="px-6 pt-2 pb-1.5 text-sm tracking-wide uppercase border border-white rounded-full text-white hover:bg-white hover:text-fordBlue">
                  Научете повече
                </button>
              </div>
            </div>
          </NavLink>
        </section>
      </div>

      {/* Kuga August 2026 Slide */}
      <div>
        <section className="relative">
          <NavLink to="/landing/kuga-august-2026" className="block">
            <div className="hidden lg:block">
              <img
                src="../images/KugaAugust2026/kuga-august-2026-desktop.jpg"
                alt="Ford Kuga August 2026"
                className="w-full"
              />
            </div>
            <div className="block lg:hidden">
              <img
                src="../images/KugaAugust2026/kuga-august-2026-mobile.jpg"
                alt="Ford Kuga August 2026"
                className="w-full"
              />
              <div className="absolute inset-x-0 px-4 text-center text-white top-8 lg:hidden">
                <h1 className="text-2xl font-fordBlack">FORD KUGA</h1>
                <p className="mt-2 text-base uppercase">
                  Самозареждащ се или Plug-in Hybrid
                </p>
              </div>
              <div className="absolute inset-x-0 px-4 text-center text-white bottom-14 lg:hidden">
                <p className="text-base uppercase">
                  на супер цена сега от 3 150 € / 6 160,86 лв.
                  <br />
                  първоначална вноска
                  <span className="text-xs align-super">*</span>
                </p>
                <button className="px-4 py-1.5 mt-3 text-sm bg-white rounded-full text-fordBlue">
                  Научете повече
                </button>
              </div>
            </div>
            <div className="absolute hidden text-left text-white left-[3%] bottom-[8%] lg:block lg:max-w-[36rem]">
              <h1 className="text-3xl font-fordBlack">FORD KUGA</h1>
              <p className="mt-4 text-xl">
                Самозареждащ се или Plug-in Hybrid
                <br />
                на супер цена сега от 3 150 € / 6 160,86 лв.
                <br />
                първоначална вноска
                <span className="text-xs align-super">*</span>
              </p>
            </div>
            <div className="absolute hidden right-[3%] bottom-[8%] lg:block">
              <button className="px-6 pt-2 pb-1.5 text-sm tracking-wide uppercase bg-white border rounded-full text-fordBlue border-fordLight hover:bg-fordBlue hover:text-white">
                Научете повече
              </button>
            </div>
          </NavLink>
        </section>
      </div>

      {/* Transit Courier Double Cab-in-Van Slide */}
      <div>
        <section className="relative">
          <NavLink
            to="/landing/transit-courier-double-cab-in-van"
            className="block"
          >
            <div className="hidden lg:block">
              <img
                src="../images/transit-courier/ford-courier-desktop.jpg"
                alt="Ford Courier"
                className="w-full"
              />
            </div>
            <div className="block lg:hidden">
              <img
                src="../images/transit-courier/ford-courier-mobile.jpg"
                alt="Ford Courier"
                className="w-full"
              />
            </div>
            <div className="absolute inset-x-0 bottom-0 flex justify-center p-6 text-center lg:inset-x-auto lg:bottom-auto lg:left-0 lg:top-0 lg:max-w-lg lg:justify-start lg:p-0 lg:text-left">
              <div className="rounded-2xl bg-black/45 px-5 py-4 text-white backdrop-blur-[2px] lg:px-6 lg:py-5 lg:backdrop-blur-none">
                <p className="text-sm tracking-wider uppercase font-fordMedium lg:text-lg">
                  Ford Courier
                </p>
                <h1 className="mt-3 text-lg leading-[1.05] uppercase font-fordBlack lg:text-2xl">
                  Сега на ексклузивна цена
                  <br />
                  <span className="text-lg">от</span> 17 890{" "}
                  <span className="text-2xl">€</span> / 34 989,79{" "}
                  <span className="text-2xl">лв.</span>
                  <br />
                  <span className="block -mt-0.5 text-lg font-fordMedium">
                    без ДДС
                  </span>
                  <div className="mt-4">
                    <button className="px-3 py-1.5 text-xs tracking-wider text-white border border-white rounded-full font-fordAntennaRegular hover:bg-white hover:text-black">
                      Научете още
                    </button>
                  </div>
                </h1>
              </div>
            </div>
          </NavLink>
        </section>
      </div>

      {/* New Transit Courier Slide
      <div>
        <section className="relative">
          <NavLink to="/new-transit-courier" className="block">
            <div className="hidden lg:block">
              <img
                src="../images/transit-courier/transit-courier-desktop.jpg"
                alt="Ford Transit Courier"
                className="w-full"
              />
            </div>
            <div className="block lg:hidden">
              <img
                src="../images/transit-courier/transit-courier-mobile.jpeg"
                alt="Ford Transit Courier"
                className="w-full"
              />
            </div>
            <div className="absolute inset-x-0 bottom-0 flex justify-center p-6 text-center lg:inset-x-auto lg:bottom-auto lg:left-4 lg:top-4 lg:max-w-xl lg:justify-start lg:p-0 lg:text-left">
              <div className="px-3 py-4 text-white lg:px-6 lg:py-5">
                <p className="text-sm tracking-wider uppercase font-fordMedium lg:text-lg">
                  Ford Transit Courier с много екстри*
                </p>
                <h1 className="text-xl leading-[1.05] uppercase font-fordBlack lg:text-2xl">
                  Сега на супер цена
                  <br />
                  <span className="text-lg">от</span> 17 700{" "}
                  <span className="text-xl">€</span> / 34 618,19{" "}
                  <span className="text-xl">лв.</span>
                  <br />
                  <span className="block -mt-0.5 text-lg font-fordMedium">
                    без ДДС
                  </span>
                  <div className="lg:mt-4">
                    <button className="px-3 py-1.5 text-xs tracking-wider text-white border border-white rounded-full font-fordAntennaRegular hover:bg-white hover:text-black">
                      Научете още
                    </button>
                  </div>
                </h1>
              </div>
            </div>
          </NavLink>
        </section>
      </div>
      */}

      {/* Puma 2025 Slide */}
      {/* <div>
        <div
          className="relative w-full bg-center bg-contain aspect-[768/950] md:aspect-[1440/516]
            md:bg-[url('https://sale.ford.bg/images/puma2024/puma-2026-desktop.jpg')]
            bg-[url('https://sale.ford.bg/images/puma2024/puma-2026-mobile.jpeg')]"
        >
          <div className="absolute text-center text-white left-1/2 transform -translate-x-1/2 top-[55%] md:top-[3%]">
            <h1 className="text-2xl font-bold leading-tight tracking-wide md:text-4xl drop-shadow-lg font-fordBold whitespace-nowrap">
              НОВИЯТ FORD PUMA
            </h1>
            <p className="text-lg tracking-wide drop-shadow-md font-fordBold whitespace-nowrap">
              Вземи сега на СПЕЦИАЛНА* цена и <br className="md:hidden" />с
              първоначален разход** <br className="md:hidden" />
              от 1 990 € / 3 892 лв.
            </p>
          </div>
          <a href="/landing/puma2026" rel="noreferrer" target="_blank">
            <button className="absolute bottom-[10%] md:bottom-[10%] transform -translate-x-1/2 left-1/2 px-4 py-2 text-sm tracking-wider text-white border bg-fordBlue border-fordBlue hover:bg-white hover:text-fordBlue rounded-full">
              Научете повече
            </button>
          </a>
        </div>
      </div> */}

      {/* 60 Years Transit Slide */}
      <div>
        <div
          className="relative w-full bg-center bg-contain aspect-[768/950] md:aspect-[1440/516]
            md:bg-[url('https://sale.ford.bg/images/sixty-years-transit/60y-transit-desktop.jpg')]
            bg-[url('https://sale.ford.bg/images/sixty-years-transit/60y-transit-mobile.jpg')]"
        >
          <div className="absolute text-center text-white left-1/2 transform -translate-x-1/2 top-[8%] md:bottom-[20%] md:top-auto">
            <h1 className="text-2xl font-bold leading-tight tracking-widest md:text-4xl drop-shadow-lg font-fordBold whitespace-nowrap">
              60 ГОДИНИ <br className="md:hidden" />
              FORD TRANSIT
            </h1>
            <p className="mt-2 text-lg tracking-widest drop-shadow-md font-fordBold whitespace-nowrap">
              №1 В СВЕТА
            </p>
          </div>
          <a
            href="/landing/sixty-years-transit"
            rel="noreferrer"
            target="_blank"
          >
            <button className="absolute bottom-[10%] md:bottom-[10%] transform -translate-x-1/2 left-1/2 px-4 py-2 text-sm tracking-wider text-white border bg-fordBlue border-fordBlue hover:bg-white hover:text-fordBlue rounded-full">
              Научете повече
            </button>
          </a>
        </div>
      </div>

      <div className="relative">
        <div
          className="relative w-full bg-center bg-contain aspect-[768/950]  md:aspect-[1438/516] 
                md:bg-[url('https://sale.ford.bg/images/puma-gen-e-desktop-vignette.jpg')] 
                bg-[url('https://sale.ford.bg/images/puma-gen-e-mobile.jpg')]"
        >
          <h2 className="absolute text-2xl text-center md:text-left text-white tracking-wider ml-6 md:ml-2 md:left-8 font-fordMedium  top-[60%] md:top-[12%]">
            Избери своя FORD PUMA<sup>®</sup>
          </h2>
          <div className="absolute flex flex-wrap flex-col md:flex-row  md:justify-start w-full gap-2 transform top-[70%] md:top-[21%] md:left-8">
            <a
              href="https://ford.bg/cars/puma-gen-e"
              rel="noreferrer"
              target="_blank"
            >
              <button className="px-4 py-2 text-xs tracking-widest text-white uppercase border bg-fordBlue btn-primary border-fordBlue hover:bg-white hover:text-fordBlue">
                Електрически модел
              </button>
            </a>
            <a
              href="https://ford.bg/cars/new-puma"
              rel="noreferrer"
              target="_blank"
            >
              <button className="px-4 py-2 text-xs tracking-widest text-white uppercase border bg-fordBlue btn-primary border-fordBlue hover:bg-white hover:text-fordBlue">
                Хибриден модел
              </button>
            </a>
          </div>
        </div>
      </div>
      <div>
        <div
          className="relative w-full bg-center bg-contain aspect-[768/950] md:aspect-[1438/516] 
                md:bg-[url('https://sale.ford.bg/images/electric-explorer-free-charging/explorer.jpg')] 
                bg-[url('https://sale.ford.bg/images/electric-explorer-free-charging/explorer-mobile.jpg')]"
        >
          <p className="absolute w-full text-3xl text-center text-white transform -translate-x-1/2 font-fordBlack left-1/2 drop-shadow-md top-[10%] md:top-[15%]">
            НОВИЯТ ИЗЦЯЛО ЕЛЕКТРИЧЕСКИ FORD EXPLORER{" "}
            <span className="text-sm align-super">®</span>
          </p>
          <a
            href="https://ford.bg/cars/new-explorer"
            rel="noreferrer"
            target="_blank"
          >
            <button className="absolute bottom-[16%] md:bottom-[12%] transform -translate-x-1/2 left-1/2 px-4 py-2 text-sm tracking-wider text-white border bg-fordBlue btn-primary border-fordBlue hover:bg-white hover:text-fordBlue">
              НАУЧЕТЕ ПОВЕЧЕ
            </button>
          </a>
        </div>
      </div>
    </Carousel>
  );
}
